import { render, staticRenderFns } from "./SfLink.vue?vue&type=template&id=79470f9a&"
import script from "./SfLink.vue?vue&type=script&lang=js&"
export * from "./SfLink.vue?vue&type=script&lang=js&"
import style0 from "./SfLink.vue?vue&type=style&index=0&id=79470f9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports